<template>
    <div>
        <div class="com-page-title">
            <div class="inner">{{ $route.meta.title }}</div>
        </div>
        <div class="com-card">
            <div class="com-card-title">住持</div>
            <div class="com-card-content">
                <ul class="list1">
                    <li v-for="lst in payload1.list" :key="lst.id" class="van-hairline--bottom" @click="viewDetail(lst, 1)">
                        <span class="name">{{ lst.name }}<font>{{ lst.livingYear ? `(${lst.livingYear})` : null }}</font></span>
                        <span>{{ lst.generation }}</span>
                    </li>
                </ul>
                <br>
                <br>
                <template v-if="!payload1.finished">
                    <p class="more" v-if="!payload1.loading" @click="getList(1)">加载更多</p>
                    <van-loading size="14px" class="more" v-else>加载中...</van-loading>
                </template>
            </div>
        </div>
        <div class="com-card">
            <div class="com-card-title">法嗣</div>
            <div class="com-card-content" style="padding-right:0;padding-left:0;">
                <ul class="list2">
                    <li v-for="lst in payload2.list" :key="lst.id" :class="{'van-hairline--right': num % 8 != 0}" @click="viewDetail(lst, 2)">
                        <span class="name vertical-lr">{{ lst.name }}<font>{{ lst.livingYear ? `(${lst.livingYear})` : null }}</font></span>
                    </li>
                </ul>
                <template v-if="!payload2.finished">
                    <p class="more" v-if="!payload2.loading" @click="getList(2)">加载更多</p>
                    <van-loading size="14px" class="more" v-else>加载中...</van-loading>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    
    export default {
        data () {
            return {
                // 住持
                payload1: {
                    page: 1,
                    list: [],
                    loading: false,
                    finished: false,
                    dict: {}
                },
                // 法嗣
                payload2: {
                    page: 1,
                    list: [],
                    loading: false,
                    finished: false,
                    dict: {}
                }
            }
        },
        mounted () {
            this.getDictDataList()
        },
        methods: {
            viewDetail (item, type) {
                this.$router.push({
                    path: '/about/formerDetail',
                    query: {
                        type,
                        id: item.id
                    }
                })
            },
            // 查询数据
            getList (type) {
                const limit = 10
                const payload = this[`payload${type}`]
                this[`payload${type}`].loading = true

                this.$aboutApi.findFormerList({
                    page: payload.page,
                    limit,
                    typeId: payload.dict.dictValue
                }).then(res => {
                    if (res.success) {
                        this[`payload${type}`].list = this[`payload${type}`].list.concat(res.data.list)
                        this[`payload${type}`].loading = false
                        this[`payload${type}`].page ++
                        if (res.data.list.length < limit) {
                            this[`payload${type}`].finished = true
                        }
                    }
                })
            },
            // 字典数据
            getDictDataList () {
                this.$baseApi.getDictData({
                    dictType: 'former',
                    page: 1,
                    limit: 999
                }).then(res => {
                    if (res.success) {
                        this.payload1.dict = res.data.list.find(v => v.dictLabel == '住持')
                        this.payload2.dict = res.data.list.find(v => v.dictLabel == '法嗣')
                        this.$nextTick(() => {
                            this.getList(1)
                            this.getList(2)
                        })
                    }
                })
            }
        },
        components: {
            
        }
    }
</script>

<style lang="less" scoped>
    .more {
        text-align: center;
        font-size: 14px;
        font-family: 'xqjxtREGULAR';
        color: #969799;
    }
    .list1 {
        li {
            font-size: 16px;
            font-family: 'xqjxtREGULAR';
            display: flex;
            justify-content: space-between;
            line-height: 45px;
            color: #BC4222;
            &:active {
                background: #f3f3f3;
            }
            .name {
                color: #000;
                font {
                    font-size: 14px;
                    color: #B27532;
                }
            }
        }
    }
    .list2 {
        display: flex;
        flex-wrap: wrap;
        li {
            width: calc(100% / 8);
            margin-bottom: 30px;
            text-align: center;
            font-size: 16px;
            color: #000;
            &:active {
                background: #f3f3f3;
            }
            font {
                font-size: 14px;
                color: #B27532;
            }
        }
    }
</style>
